// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle4 from "../../randing/RandingStyle4";

function Randing280({ urlCode, urlCodeSettingId }) {
  const treatments = [
    { value: "1c859ebc-01eb-4654-8d6e-8fa9b2048a65", label: "정밀 진단 무료" },
    { value: "e8c464fc-d95f-405b-9046-2f809a34ac6b", label: "치아교정 240만원" },
  ];
  return (
    <>
      <RandingStyle4
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/280/1.png`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/ApplyBenefitButton2.png`}
        qOptionColor="blue"
        formFieldColor="white"
        benefitInfoPosition="top"
        companyName="검단뉴욕치과의원"
        footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan2.jpg`}
        periodType="month"
        treatments={treatments}
      />
    </>
  );
}

export default Randing280;
